/* components/kitchen/AllergenControls.jsx — аллергены (ТР ТС 022/2011).
   AllergenChips    — 14 тогглов ручных аллергенов (выбирает повар), active=акцент.
   AllergenAutoHint — read-only чипы derived-аллергенов из привязанного состава
                      (визуально отличны: помечены «авто», без заливки-акцента).
   ХЕНДОФФ → frontend/src/components/ttk/. */

import { Icon } from '../ui/Icon.jsx';
import { EU_ALLERGENS } from '../../lib/adapters/ingredients.js';

  // Канон EU (14) — ровно то, что хранит/ожидает бэк (ttk.constants.EU_ALLERGENS),
  // чтобы ручные аллергены карточки совпадали с derived-агрегацией ТТК.
  const ALLERGEN_OPTIONS = EU_ALLERGENS.map((label) => ({ id: label, label }));

  function AllergenChips({ value = [], onChange, readOnly }) {
    const list = ALLERGEN_OPTIONS;
    const toggle = (label) => {
      if (readOnly) return;
      const has = value.includes(label);
      onChange && onChange(has ? value.filter((a) => a !== label) : [...value, label]);
    };
    return (
      <div className="allergen-chips" role="group" aria-label="Аллергены">
        {list.map((a) => {
          const active = value.includes(a.label);
          return (
            <button type="button" key={a.id} aria-pressed={active} disabled={readOnly}
              className={'allergen-chip' + (active ? ' is-active' : '')} onClick={() => toggle(a.label)}>
              {active && <Icon name="check" size={13} />}
              <span>{a.label}</span>
            </button>
          );
        })}
      </div>
    );
  }

  function AllergenAutoHint({ items = [], manual = [] }) {
    if (!items.length) {
      return <p className="allergen-auto allergen-auto--empty t-body-sm text-mute">Авто-аллергены появятся после привязки состава к карточкам.</p>;
    }
    return (
      <div className="allergen-auto">
        <span className="allergen-auto__label t-caption"><Icon name="sparkles" size={13} />Вычислено из состава</span>
        <div className="allergen-auto__chips">
          {items.map((a) => {
            const inManual = manual.includes(a);
            return (
              <span key={a} className={'allergen-auto__chip' + (inManual ? ' is-covered' : '')}>
                {a}{!inManual && <span className="allergen-auto__new" title="Не отмечен вручную">новый</span>}
              </span>
            );
          })}
        </div>
      </div>
    );
  }

export { AllergenChips };
export { AllergenAutoHint };
